import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';
import { ScoreSetEventsData } from '@/modules/epoch/types';
import { SignalEvent } from '@/modules/epoch/data-access';

export const getLegMovementEvents = async (
  { rootState, state, commit }: SafeAny,
  {
    studyId
  }: {
    studyId: string;
  }
) => {
  const url = `${rootState.env?.requestUrl.events}/studies/${studyId}/events`;

  state.legMovementEvents.isLoading = true;
  state.legMovementEvents.error = undefined;

  try {
    const events = await axiosInstance.get<ScoreSetEventsData>(url, {
      params: {
        eventTypes: 'Leg Movement,Periodic Leg Movement'
      }
    });

    state.legMovementEvents.isLoading = false;
    state.legMovementEvents.data = Object.keys(events.data).reduce(
      (acc, eventType) => [
        ...acc,
        ...(Array.isArray(events.data[eventType]) ? events.data[eventType] : []).map((item) => ({
          ...item,
          eventType
        }))
      ],
      [] as SignalEvent[]
    );
  } catch (error: SafeAny) {
    state.legMovementEvents.isLoading = false;
    state.legMovementEvents.data = [];

    commit(
      'addNotification',
      {
        i18nTitle: 'errorGetLegMovementEvents',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  }
};
